import React, { useState, useEffect, useCallback } from "react";
import MonacoEditor from "react-monaco-editor";
import { executeCode } from "../../services/pistonApi";
import "./CodeExecutor.css";
import { CardHeader, Button, Card, CardBody, Row, Col } from "reactstrap";
import { ResizableBox } from 'react-resizable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import 'react-resizable/css/styles.css';
import * as monaco from "monaco-editor"; // Import Monaco editor

function CodeExecutor({ languageCode, initialCode = "// Write your code here", runTestCase, children }) {
  const [code, setCode] = useState(initialCode);
  const [output, setOutput] = useState(null);


  const [widths, setWidths] = useState([100, 100, 100]);


  const language = languageCode;

  const handleChange = (newValue) => {
    setCode(newValue);
  };

  const runCode = async () => {
    try {
      const result = await executeCode(language, code);
      setOutput(result.run.stdout || result.run.stderr || "No output");

    } catch (error) {
      setOutput("Execution failed.");
    }
  };

  const options = {
    selectOnLineNumbers: true,
    readOnly: false,
    fontSize: 14,
    wordWrap: 'on',
    minimap: {
      enabled: true
    },
    scrollBeyondLastLine: false,
    automaticLayout: true
  };


  const handleResize = useCallback((index, data) => {
    const container = document.getElementById("myDiv");
    const newWidths = [...widths];
    newWidths[index] = data.size.width;
    const totalWidth = newWidths.reduce((acc, width) => acc + width, 0);
    const remainingWidth = container.clientWidth - totalWidth; // 20 is the total gap

    if (remainingWidth > 0) {
      const otherIndices = [0, 1, 2].filter((i) => i !== index);
      newWidths[otherIndices[0]] += remainingWidth / 2;
      newWidths[otherIndices[1]] += remainingWidth / 2;
    } else {
      const extraWidth = -remainingWidth / 2;
      const otherIndices = [0, 1, 2].filter((i) => i !== index);
      newWidths[otherIndices[0]] -= extraWidth;
      newWidths[otherIndices[1]] -= extraWidth;
    }

    requestAnimationFrame(() => {
      setWidths(newWidths);
    });
  }, [widths]);



  useEffect(() => {
    const container = document.getElementById("myDiv");
    const initialWidth = window.innerWidth / 3; // Adjust for the gap
    setWidths([initialWidth, initialWidth, initialWidth]);

    const handleResizeWindow = () => {
      const newWidths = [container.clientWidth / 3, container.clientWidth / 3, container.clientWidth / 3];
      setWidths(newWidths);
    };

    window.addEventListener('resize', handleResizeWindow);
    return () => window.removeEventListener('resize', handleResizeWindow);
  }, []);

  // Runs every time `output` changes
  useEffect(() => {
    if (output != null) {
      runTestCase(code, output)
    }

  }, [output]);

  // sets Monaco custom Theme
  useEffect(() => {
    monaco.editor.defineTheme("customTheme", {
      base: "vs-dark", // Can be "vs", "vs-dark", or "hc-black"
      inherit: true,
      rules: [],
      colors: {
        "editor.background": "#272727", // Change this to any color you want
      },
    });
    monaco.editor.setTheme("customTheme");
  }, []);



  return (




    <Row id="myDiv" className="p-0 m-0 grayBorderB  fullWitdthHeight   "  >

      <Col className=" p-0 m-0 fullWitdthHeight resizable-container">
        {/* <div className="resizable-container fullWitdthHeight  "> */}
        <ResizableBox
          width={widths[0]}
          height={"100%"}
          minConstraints={[100, 100]}
          resizeHandles={['e']}
          // className="resizable"
          onResizeStop={(e, data) => handleResize(0, data)}
        >
          {children}
        </ResizableBox>
        {/* </div> */}
      </Col>
      <Col className=" p-0 m-0  fullWitdthHeight resizable-container">
        {/* <div className="resizable-container  fullWitdthHeight"> */}
        <ResizableBox
          width={widths[1]}
          height={Infinity}
          minConstraints={[100, 100]}
          resizeHandles={['e', 'w']}
          // className="resizable"
          onResizeStop={(e, data) => handleResize(1, data)}
        >

          <Card className="fullWitdthHeight transparent-card ">
            <CardHeader className="  grayBackground4 grayBorderB d-flex  lesson-header">


              <Button onClick={runCode} size="sm" color="success">
                <FontAwesomeIcon icon={faPlay} size="xs" />
                &nbsp; Run
              </Button>
            </CardHeader>

            <CardBody className=" removeCardBodyPadding ">
              <div className=" grayBackground5 fullWitdthHeight ">
                <MonacoEditor
                  language={language}
                  theme="vs-dark"
                  value={code}
                  onChange={handleChange}
                  options={options}
                />
              </div>
            </CardBody>

            {/* <CardFooter className=" lightGrayBackground1">
                        <Button onClick={runCode} color="success">
                            <FontAwesomeIcon icon={faPlay} />
                            &nbsp; Run
                        </Button>
                    </CardFooter>
                    <CardFooter className=" lightGrayBackground2">
                        <Button onClick={runCode} color="success">
                            <FontAwesomeIcon icon={faPlay} />
                            &nbsp; Run
                        </Button>
                    </CardFooter>
                    <CardFooter className=" lightGrayBackground3">
                        <Button onClick={runCode} color="success">
                            <FontAwesomeIcon icon={faPlay} />
                            &nbsp; Run
                        </Button>
                    </CardFooter> */}


            {/* <CardFooter className=" grayBorderT   grayBackground4">
                                <Button onClick={runCode} size="sm" color="success">
                                    <FontAwesomeIcon icon={faPlay} />
                                    &nbsp; Run
                                </Button>
                            </CardFooter> */}


          </Card>
        </ResizableBox>
        {/* </div> */}
      </Col>


      <Col className=" p-0 m-0 fullWitdthHeight resizable-container">
        {/* <div className="resizable-container  fullWitdthHeight"> */}
        <ResizableBox
          width={widths[2]}
          height={Infinity}
          minConstraints={[100, 100]}
          resizeHandles={['e', 'w']}
          // className="resizable"
          onResizeStop={(e, data) => handleResize(2, data)}
        >
          <div className=" grayBorderL" style={{ width: '100%', height: '100%' }}>
            <div className="card styleCard h-100 whiteText">
              {output}
            </div>
          </div>
        </ResizableBox>
        {/* </div> */}
      </Col>






    </Row>




  );
}

export default CodeExecutor;
